export const exerciseCalories = {
  yoga: {
    caloriePerUnit: 4,
    type: "Yoga",
    imgSrc:
      "https://images.pexels.com/photos/16148425/pexels-photo-16148425/free-photo-of-black-and-white-photo-of-women-in-yoga-poses.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  aerobic: {
    caloriePerUnit: 15,
    type: "Aerobics",
    imgSrc:
      "https://images.pexels.com/photos/2345293/pexels-photo-2345293.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  strengthTraining: {
    caloriePerUnit: 45,
    type: "Strength Training",
    imgSrc:
      "https://images.pexels.com/photos/5209197/pexels-photo-5209197.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  cycling: {
    caloriePerUnit: 13,
    type: "Cycling",
    imgSrc:
      "https://images.pexels.com/photos/13877085/pexels-photo-13877085.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  walking: {
    caloriePerUnit: 7,
    type: "Walking",
    imgSrc:
      "https://images.pexels.com/photos/5867971/pexels-photo-5867971.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  running: {
    caloriePerUnit: 12,
    type: "Runing",
    imgSrc:
      "https://images.pexels.com/photos/18492717/pexels-photo-18492717/free-photo-of-sport-marathon-fitness-athlete.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
};
